import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Cp from './Cp'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export default function Navbar(props) {
    return (
        <div>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid" >
                    <Link className="navbar-brand" to="/" >{props.title}</Link>
                    <button className="navbar-toggler"  type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" ></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent" >
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="/Home" >Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/about" >{props.About}</Link>
                            </li>
                        </ul>
                        <form className="d-flex" role="search">
                            {/* <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">Search</button> */}
                            <Cp color1="red" color2="yellow" color3="blue"/>
                            <Cp color1="green" color2="grey" color3="blue"/>
                            <Cp color1="red" color2="yellow" color3="blue"/>
                            <div className="form-check form-switch align-canter"style={{color:props.mode==='light'?'black':'white'}}>
                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{props.mode[0].toUpperCase()+props.mode.slice(1).toLowerCase()+' mode'}</label>
                                <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                            </div>
                        </form>
                    </div>
                </div>
            </nav>
        </div>
    )
}
Navbar.propTypes = {
    title: PropTypes.string,
    About: PropTypes.string
}


Navbar.defaultProps = {
    title: 'Brand',
    About: 'About'
}


